var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2227 19.1111C16.3272 19.1111 17.2227 18.2157 17.2227 17.1111V3.11111C17.2227 2.00654 16.3273 1.11111 15.2227 1.11111H4.22266C3.11809 1.11111 2.22266 2.00654 2.22266 3.11111V17.1111C2.22266 18.2157 3.11809 19.1111 4.22266 19.1111H15.2227Z",
    stroke: "#0D0D0D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.3333L15 14.3333",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5557 11L14.5557 11",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 1.11111V8.1553C4.44434 8.42388 4.77018 8.55713 4.95837 8.36551L7.00808 6.27854C7.12566 6.15882 7.31857 6.15882 7.43615 6.27854L9.48586 8.36551C9.67405 8.55713 9.99989 8.42388 9.99989 8.1553V1.11111",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanAutomation);
export default __webpack_public_path__ + "static/media/icon-plan-automation.72826f968cb4207a79023ce3596389d7.svg";
export { ForwardRef as ReactComponent };